import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=65b23898&scoped=true"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"
import style0 from "./Content.vue?vue&type=style&index=0&id=65b23898&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b23898",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65b23898')) {
      api.createRecord('65b23898', component.options)
    } else {
      api.reload('65b23898', component.options)
    }
    module.hot.accept("./Content.vue?vue&type=template&id=65b23898&scoped=true", function () {
      api.rerender('65b23898', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/social_school/Content.vue"
export default component.exports